export default __webpack_public_path__ + "static/media/walletConnect.cc6e5709.svg";